// Abrupt cycle count exit (#3924 / #4187): after the orchestrator exit is requested, every
// still-open cycle count task is sent to PUT PickStation/abortCycleCount in one list. The API
// sends a single PLC commandType 18 for the whole list and aborts the tasks on the PLC ack.
// Kept as a pure function so the selection logic is unit-testable in isolation.

export interface CycleCountTaskRef {
  id: string;
  isComplete: boolean;
}

export function pendingCycleCountTaskIds(tasks: CycleCountTaskRef[]): string[] {
  return Array.from(
    new Set(tasks.filter((t) => !t.isComplete && t.id).map((t) => t.id))
  );
}
